import axios from "../plugins/parseAxios";
export class ReceiptAPI {
  static createReceipt(postData) {
    return axios.post("functions/createReceipt", postData);
  }
  static updateReceipt(postData) {
    return axios.post("functions/updateReceipt", postData);
  }
  static updateReceiptCustomerData(postData) {
    return axios.post("functions/updateReceiptCustomerData", postData);
  }
  static payReceipt(postData) {
    return axios.post("functions/payReceipt", postData);
  }
  static unpaidReceipt({ id, note }) {
    return axios.post("functions/unpaidReceipt", {
      id,
      note
    });
  }
  static getReceiptsByInvoice(invoiceId) {
    return axios.post("functions/getReceiptsByInvoice", {
      invoiceId
    });
  }
  static getReceiptsBetweenDateByMarket(fromData) {
    return axios.post("functions/getReceiptsBetweenDateByMarket", fromData);
  }
  static getReceiptsBetweenDateByProject(fromData) {
    return axios.post("functions/getReceiptsBetweenDateByProject", fromData);
  }
  static getReceipt(receiptId) {
    return axios.post("functions/getReceipt", {
      id: receiptId
    });
  }
  static getDepositReceiptsByContracts(payload) {
    return axios.post("functions/getDepositReceiptsByContracts", payload);
  }
  static getReceiptOverallMonthly(fromData) {
    return axios.post("functions/getReceiptOverallMonthly", fromData);
  }
}
